import React, { useState } from 'react'
import _ from 'lodash'
import {
  Col
} from 'camino-react'

import ClientContactForm from './ClientContactForm'
import UserCreateForm from 'Components/Users/Create/Form'

const getClientNotices = (notices) => {
  const clientNoticesContent = []

  _.forEach(notices, (notice) => {
    cloudhelpGet(`/api/notices/${notice.notice_id}`)
      .then((response) => {
        const { data: { content } } = response

        clientNoticesContent.push(content)
      })
    this.setState({
      clientNoticesContent: clientNoticesContent,
    })
  })
}

const checkForClientNotices = (selectedOption = {}) => {
  const { getClientNotices } = this

  cloudhelpGet(`/api/associated_notices/Client/${selectedOption.value}`)
    .then((response) => {
      const { data: notices } = response

      _.some(notices) && getClientNotices(notices)
    })
}

const ClientContactSelectionArea = ({
  clients,
  setFieldErrorClasses,
  clientContactsLoading,
  clientNoticesContent,
  currentUser,
  creatingContact,
  creatingContactForClient,
  setFieldValue: setFormState,
  clientsPropertiesWithHandlers,
  addClientContactListToClient,
  contactNumber,
  disabledContactNotifications,
  securityIssue
}) => {
  let clientOptions = []
  const usedClientsIds = _.map(clientsPropertiesWithHandlers, clientProperties => clientProperties.client_id)
  clientOptions = _.map(clients, ({
    value,
    label,
    region_id,
    users,
    keyClient,
    clientStatus,
    migratedToHalo
  }) => ({
    value,
    label,
    region_id,
    users,
    disabled: _.includes(usedClientsIds, value),
    keyClient,
    clientStatus,
    migratedToHalo
  }))
  const twoOrMoreClients = clientsPropertiesWithHandlers.length > 1

  if (creatingContact) {
    return (
      <UserCreateForm
        clientId={creatingContactForClient}
        currentUser={currentUser}
        afterSave={(response) => {
          const user = response.data.user
          const clientProperties = _.find(clientsPropertiesWithHandlers, ['client_id', user.client_id])
          const users = _.get(_.find(clientOptions, ['value', user.client_id]), 'users', [])
          const userOption = { value: user.id, label: user.name, email: user.email }
          users.push(userOption)

          setFormState('creatingContact', false)
          setFormState('creatingContactForClient', null)
          addClientContactListToClient(user.client_id, users)
          clientProperties.setFieldValue('primary_contact_email', user.email)
          setFormState('primary_contact_email', user.email)
          clientProperties.setFieldValue('primary_contact_name', user.name)
          setFormState('primary_contact_name', user.name)
          clientProperties.setFieldValue('client_contact_id', user.id)
          setFormState('client_contact_id', user.id)
        }}
        onCancel={() => {
          setFormState('creatingContact', false)
          setFormState('creatingContactForClient', null)
        }}
        groupsOptions={[
          { label: 'User', value: 9 },
          { label: 'Client Admin', value: 10 },
          { label: 'Partner Admin', value: 11 },
        ]}
      />
    )
  }

  return (
    <div>
      {_.map(clientsPropertiesWithHandlers, (clientProperties, index) => (
        <div key={index} style={{ paddingBottom: '50px' }}>
          <ClientContactForm
            clientOptions={clientOptions}
            setFieldErrorClasses={setFieldErrorClasses}
            currentUser={currentUser}
            clientNoticesContent={clientNoticesContent}
            clientContactsLoading={clientContactsLoading}
            clientProperties={clientProperties}
            setFormState={setFormState}
            addClientContactListToClient={addClientContactListToClient}
            contactNumber={contactNumber}
            disabledContactNotifications={disabledContactNotifications}
            securityIssue={securityIssue}
          />

          {twoOrMoreClients && (
            <div style={{ borderBottom: '1px solid rgb(212, 212, 212)' }}>
              <div className="row no-gutters" style={{ alignItems: 'center' }}>
                <Col width={24}>
                  <button onClick={() => clientProperties.remove()} type="button" className="button button--link" style={{ padding: 'initial' }}>
                    <span style={{ border: '0' }} className={'lnr lnr-minus lnr-inline lnr-black lnr-small'} />
                    {' '}
                    {'Remove Client'}
                  </button>
                </Col>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>

  )
}

export default ClientContactSelectionArea
